document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});
